import { render, staticRenderFns } from "./Dashboard_EM.vue?vue&type=template&id=068f1b2e&scoped=true&"
import script from "./Dashboard_EM.vue?vue&type=script&lang=js&"
export * from "./Dashboard_EM.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_EM.vue?vue&type=style&index=0&id=068f1b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068f1b2e",
  null
  
)

export default component.exports